import React from "react";
import {TableWrapper} from "../../styles/globalStyles";
import DependantsTable from "../dependants/DependantsTable";
import {ROUTES} from "../../utils/RouteConstants";
import {useHistory} from "react-router-dom";
import FetchState from "../../api/FetchState";
import LoadingIcon from "../../shared/LoadingIcon";
import {useFetchMembersDependants} from "./hooks";
import { NarrowButton } from "../../styles/globalStyles";

let dependantTableHeaders = {
    columns: [
        { title: "Name", field: "name" },
        { title: "Surname", field: "surname" },
        { title: "Child", field: "child", type : "boolean" },
        { title: "Claimed", field: "claimed", type:"boolean" },
        { title: "Relationship", field: "relationship.name" },
    ],
}

export default function MemberFormDependantTable ({member}) {

    let history = useHistory();
    const [dependants, fetchState] = useFetchMembersDependants();

    if (FetchState.SUCCESS === fetchState)
        return (
            <TableWrapper>
                <DependantsTable
                    last = {ROUTES.MEMBERS_FORM}
                    tableData = {dependants}
                    tableHeaders = {dependantTableHeaders}
                    member = {member}
                />
                <div role="row-sections">
                    <NarrowButton type="button"
                            onClick= {() =>
                                history.push(ROUTES.DEPENDANTS_FORM, { member , last: ROUTES.MEMBERS_FORM})}
                    >
                        Add New
                    </NarrowButton>

                </div>
            </TableWrapper>
    )
    else return <LoadingIcon />

}